import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { MdExitToApp } from 'react-icons/md'
import { PushSpinner } from "react-spinners-kit"

import Order from '../Order'
import TemplatesPage from '../../pages/TemplatesPage/'
import CabinetPage from '../../pages/CabinetPage/'

import './MainMenu.scss'

@observer
class MainMenu extends Component {
  state = { 
    activeTab: 0,
  }

  chgActiveTab = id => {
    this.setState({activeTab: id})
  }
  render() {
    return (<>
      <div>
        <ul className="main-menu">
          <li className={this.state.activeTab === 0 ? 'active' : null } onClick={() => this.chgActiveTab(0)}>Заказ</li>
          <li className={this.state.activeTab === 1 ? 'active' : null } onClick={() => this.chgActiveTab(1)}>Шаблоны</li>
          <li className={this.state.activeTab === 2 ? 'active' : null } onClick={() => this.chgActiveTab(2)}>Кабинет</li>
          <li onClick={this.props.logout}><MdExitToApp /></li>
        </ul>
      </div>
      <div className="full-order-form">
        {this.state.activeTab === 0 ? (<>
          <Order />
          {this.props.orderStage ? <div className="order-preloader">
          <PushSpinner size={30} color="#283D5C" loading={true} />
          </div> : null}
        </>) 
        : null }
        {this.state.activeTab === 1 ? <TemplatesPage /> : null }
        {this.state.activeTab === 2 ? <CabinetPage /> : null }
      </div></>
    )
  }
}

const withData = inject(stores => ({
  logout: stores.LoginFromStore.logout,
  orderStage: stores.OrderStore.orderStage,
}))

export default withData(MainMenu);
